/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { MultiSelect } from '@livechat/design-system'

import { formatItem } from './SurveyLabels'

const SurveyLabelsSelect = ({
  selectedItems,
  setSelectedItems,
  licenseGroupingLabels,
  assignLabelToSurvey,
  removeLabelFromSurvey,
}) => {
  const handleItemSelect = (item) => {
    if (selectedItems.find((selected) => selected.key === item)) {
      removeLabelFromSurvey(item)
      return setSelectedItems(selectedItems.filter((i) => i.key !== item))
    } else {
      assignLabelToSurvey(item)
      return setSelectedItems([...selectedItems, formatItem(item)])
    }
  }

  const handleItemRemove = (item) => {
    removeLabelFromSurvey(item)
    const newState = selectedItems.filter((selected) => selected.key !== item)
    return setSelectedItems(newState.length > 0 ? newState : [])
  }

  const getItemBody = (props) => {
    if (!props) {
      return null
    }
    return <div id={props.value}>{props.name}</div>
  }

  const getSelectedItemBody = (props) => {
    return <div id={props.value}>{props.name}</div>
  }

  const selected = selectedItems.map((item) => item.props.value)

  return (
    <div style={{ height: '40px' }}>
      <MultiSelect
        searchProperty="name"
        search
        items={licenseGroupingLabels}
        onItemSelect={handleItemSelect}
        onItemRemove={handleItemRemove}
        getItemBody={getItemBody}
        maxItemsContainerHeight={72}
        getSelectedItemBody={getSelectedItemBody}
        selected={selected}
        placeholder="Search for labels..."
        css={css`
          height: 40px;
          width: 100%;

          .lc-multiselect-head {
            border-color: #cfd3d5;
            height: 40px;
          }

          .material-menu-down-icon {
            margin-top: 8px;
          }

          .lc-multiselect-head__search {
            margin-left: 0;
            padding-left: 0;
            font-size: 15px;
          }

          .lc-multiselect-head__search::placeholder {
            color: #bcc6d0 !important;
          }

          .lc-multiselect-head__item {
            background-color: #e9f0ff;
            color: #4384f5;
            border-radius: 20px;
          }

          .lc-multiselect-head__item-remove-icon {
            fill: #4384f5;
            margin-top: 3px;
            margin-right: 5px;
            opacity: 1;
          }
        `}
      />
    </div>
  )
}

export default SurveyLabelsSelect
